import { sylvanus } from '~/services/serviceInstances';
import { Uuid } from '~/types/Uuid';

interface Request {
  modelId: Uuid;
  version: number;
}

export const executePromptModelTestCases = async ({
  modelId,
  version,
}: Request): Promise<void> => {
  await sylvanus.post(`/model/${modelId}/version/${version}/execute`);
  return;
};
